import React from 'react'

import { Text } from '@domain-group/suit-theme'

interface TitleProps {
  children: React.ReactNode,
}

const Title = (props: TitleProps) => {
  const { children } = props

  return (
    <Text fontSize="small">
      {children}
    </Text>
  )
}

export default Title
